import React from 'react';

const StockAnalysisReportFormModal = React.lazy(() => import('../components/FormModal'));
const stockAnalysisReportModalRegistry = {
    company_stockAnalysisReportId: StockAnalysisReportFormModal
};
export default stockAnalysisReportModalRegistry;
